import { getRequest, postRequest } from "../utils/axios";

const projectQuery = (projectHash) => `?project=${projectHash}`;

export const seoService = {
  listReports: (projectHash, filters, onSuccess, onError) => {
    const params = new URLSearchParams({ project: projectHash });
    if (filters?.type && filters.type !== "all") params.set("type", filters.type);
    if (filters?.page) params.set("page", String(filters.page));
    return getRequest(`/api/v1/seo-reports/?${params}`, onSuccess, onError);
  },
  getReport: (hash, projectHash, onSuccess, onError) =>
    getRequest(`/api/v1/seo-reports/${hash}/${projectQuery(projectHash)}`, onSuccess, onError),
  createReport: (projectHash, data, onSuccess, onError) =>
    postRequest(
      `/api/v1/seo-reports/${projectQuery(projectHash)}`,
      data,
      onSuccess,
      onError,
    ),
  listPages: (projectHash, filters, onSuccess, onError) => {
    const params = new URLSearchParams({ project: projectHash });
    if (filters?.report) params.set("report", filters.report);
    return getRequest(`/api/v1/seo-pages/?${params}`, onSuccess, onError);
  },
  listIssues: (projectHash, filters, onSuccess, onError) => {
    const params = new URLSearchParams({ project: projectHash });
    if (filters?.report) params.set("report", filters.report);
    return getRequest(`/api/v1/seo-issues/?${params}`, onSuccess, onError);
  },
  listSuggestions: (projectHash, filters, onSuccess, onError) => {
    const params = new URLSearchParams({ project: projectHash });
    if (filters?.status) params.set("status", filters.status);
    if (filters?.report) params.set("report", filters.report);
    return getRequest(`/api/v1/seo-suggestions/?${params}`, onSuccess, onError);
  },
};
